import { createFileRoute } from '@tanstack/react-router';

import {
  revenueSummaryQueryOptions,
  revenueTransactionsQueryOptions,
} from '@/features/revenue/api';
import { RevenuePage } from '@/features/revenue/components/revenue-page';
import {
  resolveTransactionMonth,
  revenueSearchSchema,
  revenueSummaryRange,
  transactionRange,
} from '@/features/revenue/search';

export const Route = createFileRoute('/_app/revenue')({
  validateSearch: revenueSearchSchema,
  loaderDeps: ({ search }) => search,
  staticData: { title: '수익', group: '통계' },
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient
      .query(revenueSummaryQueryOptions(revenueSummaryRange(deps.period)))
      .catch(() => undefined);
    void queryClient
      .infiniteQuery(
        revenueTransactionsQueryOptions({
          ...transactionRange(resolveTransactionMonth(deps.month)),
          ...(deps.source === 'ALL' ? {} : { source: deps.source }),
        }),
      )
      .catch(() => undefined);
  },
  head: () => ({ meta: [{ title: '수익 · 팬즈드롭 파트너' }] }),
  component: RevenueRoute,
});

function RevenueRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <RevenuePage
      search={search}
      onSearchChange={next => {
        void navigate({
          search: previous => ({ ...previous, ...next }),
          replace: true,
          resetScroll: false,
        });
      }}
    />
  );
}
